<template>
    <div>
        <input type="hidden" name="event" :value="eventId">
        <div class="form-group">
            <label class="sr-only" :for="id">Question</label>
            <textarea class="form-control"
                      v-model="question"
                      :id="id"
                      :name="name"
                      :rows="rows"
                      :minlength="minlength"
                      :maxlength="maxlength"
                      :placeholder="placeholder"
                      :disabled="!onAir"
                      :style="{cursor: cursorStyle}"
            >
        </textarea>
        </div>
        <button type="button" class="btn btn-secondary btn-block mb-2 p-2" @click="onSubmit" :disabled="!canSubmit">
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
  name: 'QuestionTextarea',

  data () {
    return {
      question: '',
      placeholder: '',
      onAir: false,
      serverTimestamp: 0,
      openInterval: {},
      closeInterval: {},
      startOn: 0,
      endOn: 0,
      message: {
        zhtw: {
          sentFailed: '訊息無法發送',
          questionSent: '訊息已傳送',
          questionPlaceholder: '請至少輸入10個字元',
          questionDisabledPlaceholder: '僅開放會議期間提問'
        },
        en: {
          sentFailed: 'The message cannot send',
          questionSent: 'The message has been sent.',
          questionPlaceholder: 'At least 10 words',
          questionDisabledPlaceholder: 'Ask questions during meetings only'
        }
      }
    }
  },

  props: {
    lang: {
      type: String,
      default: 'zhtw'
    },
    url: {
      type: String,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    rows: {
      type: Number,
      default: 6
    },
    minlength: {
      type: Number,
      default: 10
    },
    maxlength: {
      type: Number,
      default: 500
    },
    timestampUrl: {
      type: String,
      required: true
    },
    manuallyOpen: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onSubmit() {
      axios.post(this.url, {
        event: this.eventId,
        question: this.question
      })
      .then(response => {
        if (response.status === 200) {
          this.question = '';
          this.$message({
            message: this.message[this.lang].questionSent,
            type: 'success'
          });
        }
      })
      .catch((error) => {
        let errorMsg = this.message[this.lang].sentFailed;
        if (error.response && error.response.data) {
          const detail = error.response.data.error || error.response.data.message;
          if (detail) {
            errorMsg += `: ${detail}`;
          }
        }

        this.$message({
          message: errorMsg,
          type: 'error'
        });
      });
    },
    airStatus(status) {
      if (status === 'on') {
        this.onAir = true;
        this.placeholder = this.message[this.lang].questionPlaceholder;
      } else {
        this.onAir = false;
        this.question = '';
        this.placeholder = this.message[this.lang].questionDisabledPlaceholder;
      }
    }
  },

  computed: {
    canSubmit() {
      return (this.onAir && this.question.length >= this.minlength)
    },
    cursorStyle() {
      return this.onAir ? 'text' : 'not-allowed';
    }
  },

  watch: {
    // 手動開啟、手動關閉後，清除計時器
    manuallyOpen(newValue, oldValue) {
      // 手動開啟
      if (newValue && !oldValue) {
        // console.log('manually open');
        this.airStatus('on');
        clearInterval(this.openInterval);
      }

      // 手動關閉
      if (!newValue && oldValue) {
        // console.log('manually close');
        this.airStatus('off');
        clearInterval(this.closeInterval);
      }
    }
  },

  created() {
    this.placeholder = this.message[this.lang].questionPlaceholder;

    axios.post(this.timestampUrl, { event_id: this.eventId })
      .then(response => {
        this.serverTimestamp = response.data.now;
        this.startOn = response.data.start_time;
        this.endOn = response.data.end_time;

        setInterval(() => {
          this.serverTimestamp++;
        }, 1000);

        this.openInterval = setInterval(() => {
          if (this.serverTimestamp && this.startOn && this.serverTimestamp >= this.startOn) {
            this.airStatus('on');
            clearInterval(this.openInterval);
          }
        }, 1000);

        this.closeInterval = setInterval(() => {
          if (this.serverTimestamp && this.endOn && this.serverTimestamp >= this.endOn) {
            this.airStatus('off');
            clearInterval(this.closeInterval);
          }
        }, 1000);
      });
  }
}
</script>

<style scoped>

</style>
